/* unplugin-vue-components disabled */import script from "./QueryNotBank.vue?vue&type=script&setup=true&lang=js"
export * from "./QueryNotBank.vue?vue&type=script&setup=true&lang=js"

import "./QueryNotBank.vue?vue&type=style&index=0&id=e2e002f2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2e002f2"]])

export default __exports__